<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-md-6">
        <Button @click="getRandomFace">Get random face</Button>
        <div class="d-flex justify-content-between flex-wrap">
          <template v-for="(item, index) in slidersMin">
            <Slider
              :name="getSliderName(index)"
              :min="item"
              :key="index"
              :index="index"
              :max="getSliderMax(index)"
              :allSlidersValues="allSlidersValues"
              @drag="triggerSliderArrayUpdate"
            />
          </template>
        </div>
      </div>
      <div class="col-md-6">
        <Renderer :allSlidersValues="allSlidersValues"/>
        <p>
          There are {{ componentsCount }} components starting
          from most important to least important.
        </p>
        <p>Use sliders to modify face image or press button to generate a random image.</p>
        <p>
          This projet was made using vueJs and tensorflowJs.
          Model was trained on gpu in tensorflow keras in python and then exported to tensorflowJs format using tensorflowjs_converter.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import Button from "./components/Button.vue";
import Slider from "./components/Slider.vue";
import Renderer from "./components/Renderer.vue";

import slidersMax from "./data/slidersMax.json";
import slidersMin from "./data/slidersMin.json";
import facesPca from "./data/facesPca.json";

export default {
  name: "app",
  components: {
    Button,
    Slider,
    Renderer
  },
  mounted() {
    for (let i = 0; i < slidersMin.length; ++i) {
      this.allSlidersValues.push(
        slidersMin[i] + (slidersMax[i] - slidersMin[i]) / 2
      );
    }
  },
  data() {
    return {
      slidersMax,
      slidersMin,
      facesPca,
      componentsCount: slidersMax.length,
      facesCount: facesPca.length,
      allSlidersValues: []
    };
  },
  methods: {
    getSliderMax(index) {
      return this.slidersMax[index];
    },
    getSliderName(index) {
      switch (index) {
        default:
          return "# " + index;
      }
    },
    getRandomFace() {
      const max = this.facesCount;
      const randomFaceId = Math.floor(Math.random() * (max - +1));
      this.allSlidersValues = this.facesPca[randomFaceId];
    },
    triggerSliderArrayUpdate() {
      this.allSlidersValues = this.allSlidersValues.slice();
    }
  }
};
</script>

<style>
</style>
